export const AccountAccessRight = {
  "SI000014": "pro-team",
  "SI000009": "pro-team",
  "SI000015": "admin",
  "SI000016": "admin",
  "SI000001": "admin",
  "SI000018": "scout",
  "SI000013": "scout"
}

export const ACCESS_MAP = {
  "pro-team": {
    "中華職棒": 'J61qWKmDQnVG3VoARPPgm4hAWuaCai0'
  },
  "admin": {
    "中華職棒": 'J61qWKmDQnVG3VoARPPgm4hAWuaCai0',
    "新北富邦U18": 'YxT857AIEnZWVYILOyI43GjDAhVVVCgX',
    "木棒聯賽": 'ZoMaSDeEi3pVmjJz2BM1clpG50IJkdEl'
  },
  "recorder": {
    "新北富邦U18": 'YxT857AIEnZWVYILOyI43GjDAhVVVCgX',
    "木棒聯賽": 'ZoMaSDeEi3pVmjJz2BM1clpG50IJkdEl'
  },
  "scout": {
    "中華職棒": 'J61qWKmDQnVG3VoARPPgm4hAWuaCai0',
    "新北富邦U18": 'YxT857AIEnZWVYILOyI43GjDAhVVVCgX',
    "木棒聯賽": 'ZoMaSDeEi3pVmjJz2BM1clpG50IJkdEl'
  }
}

export const ACCESS_PAGE_MAP = {
  "pro-team": ['hls'],
  "admin": ['hls', 'youtube', 'nas', 'hls-url'],
  "recorder": ['hls', 'youtube'],
  "scout": ['hls', 'youtube', 'nas', 'hls-url']
}

export const PAGE_NAME_MAP = {
  'hls':  '資料庫影片',
  'youtube': 'YouTube',
  'hls-url': 'M3U8 URL',
  'nas': 'NAS影片'
}